import {mergeConfigs} from '../../../../theme/app.modules';

const HIVE_MODULES = {};

const finalMergedConfig = mergeConfigs(HIVE_MODULES);

export default finalMergedConfig;



